import { setAnalyticsCollectionEnabled } from "firebase/analytics";
import React from "react";
import { analytics } from "../../Firebase";
import { useConfig } from "../../hooks/ConfigProvider";
import { useTheme } from "../../hooks/ThemeContext";
import { getRemoteEnv } from "../../config/remoteEnv";


const PrivacyPolicy = () => {

    const handleClearPreferences = () => {

        // Clear both storage locations
        localStorage.removeItem('cookieConsent');
        sessionStorage.removeItem('cookieConsent');
        
        // Disable analytics
        setAnalyticsCollectionEnabled(analytics, false);
        
        // Reload the page to show the cookie banner again
        window.location.reload();
    };

    const { config } = useConfig();
    const { theme } = useTheme();
    const env = getRemoteEnv();

    console.log("11: privacy policy?", env)

    if (env.privacyPolicy) {

        return (
            <div style={{display: "flex", flexDirection: "column", padding: "2%", width: "100%", overflowY: "scroll", color: theme.textColor}}>
                <div className="cookie-preferences-reset" style={{textAlign: "left"}}>
                    <p>Click the button below to clear your current cookie preferences and reset your choices:</p>
                    <button 
                        onClick={handleClearPreferences}
                        className="reset-preferences-button"
                    >
                        Reset Cookie Preferences
                    </button>
                </div>
                <div dangerouslySetInnerHTML={{ __html: env.privacyPolicy }} />
            </div>
        );
    }

    return (

        <div style={{padding: "40px", paddingTop: "0px", overflowY: "scroll", textAlign: "left", color: theme.textColor}}>

            <h1>Privacy Policy</h1>

            <p>Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website and place orders online.</p>

            <h2>1. Information We Collect</h2>
            <p>When you place an order on our website, we collect the following personal information:</p>
            <ul>
                <li><strong>Personal Identification Information:</strong> Your name, email address, and phone number.</li>
                <li><strong>Payment Information:</strong> Credit or debit card details used for processing payments. We do not store your card information; it is securely handled by our payment processor.</li>
                <li><strong>Order Details:</strong> Information about the items you order from our menu.</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <p>We use your personal information for the following purposes:</p>
            <ul>
                <li><strong>To process your order:</strong> We use your personal and payment information to fulfill and confirm your order.</li>
                <li><strong>To communicate with you:</strong> We may contact you via email or phone to provide updates on your order or respond to your inquiries.</li>
                <li><strong>To improve our services:</strong> We analyze customer data to enhance the user experience on our website and improve the quality of our service.</li>
                <li><strong>For marketing (if opted-in):</strong> If you have opted in to receive promotional emails, we will use your email address to send you news, special offers, and promotions. You can opt out at any time.</li>
            </ul>

            <h2>3. How We Protect Your Information</h2>
            <p>We are committed to ensuring that your information is secure. To prevent unauthorized access or disclosure, we have implemented appropriate physical, electronic, and managerial procedures to safeguard the information we collect online.</p>
            <p>We use a secure payment gateway to process your transactions, and all payment information is encrypted.</p>

            <h2>4. Sharing Your Information</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. However, we may share your information with trusted third parties who help us operate our website, process payments, or provide customer service, provided they agree to keep this information confidential.</p>
            <p>We may also disclose your personal information if required by law or if we believe that such action is necessary to comply with a legal obligation or protect the rights, property, or safety of ourselves and others.</p>

            <h2>5. Cookies</h2>
            <p>Our website uses cookies to enhance your browsing experience. Cookies are small text files that are placed on your device when you visit our website. These files help us remember your preferences and provide a personalized experience.</p>

            <h3>5.1 Types of Cookies We Use</h3>
            <p>We use the following types of cookies:</p>
            <ul>
                <li><strong>Necessary Cookies:</strong> These cookies are essential for the website to function properly. They enable basic functions like page navigation, payment processing, and access to secure areas of the website. The website cannot function properly without these cookies.</li>
                
                <li><strong>Analytics Cookies:</strong> We use Google Analytics cookies to understand how visitors interact with our website. These cookies help us analyze and improve our website by collecting anonymous information about how you use it.</li>
                
                <li><strong>Marketing Cookies:</strong> These cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for individual users.</li>
            </ul>

            <h3>5.2 Cookie Management</h3>
            <p>When you first visit our website, you will be presented with a cookie consent banner where you can:</p>
            <ul>
                <li>Accept all cookies</li>
                <li>Manage your cookie preferences</li>
                <li>Reject non-essential cookies</li>
            </ul>

            <p>You can also choose to disable cookies through your browser settings at any time. However, please note that if you disable certain cookies, some features of the website may not function properly.</p>

            <h3>5.3 Cookie Duration</h3>
            <p>The cookies we use may be:</p>
            <ul>
                <li><strong>Session Cookies:</strong> These temporary cookies are erased when you close your browser</li>
                <li><strong>Persistent Cookies:</strong> These cookies remain on your device until they expire or you delete them</li>
            </ul>

            <h3>5.4 Third-Party Cookies</h3>
            <p>Some cookies are placed by third-party services that appear on our pages:</p>
            <ul>
                <li><strong>Google Analytics:</strong> Used for website analytics and performance monitoring</li>
                <li><strong>Firebase:</strong> Used for analytics and website functionality</li>
                <li><strong>Stripe:</strong> Used for secure payment processing. Stripe sets necessary cookies to prevent fraud and ensure secure transactions during the checkout process. These cookies are essential for processing payments and cannot be disabled.</li>
            </ul>

            <h3>5.5 Your Choices</h3>
            <p>You can manage your cookie preferences in several ways:</p>
            <ul>
                <li>Through your browser settings - you can delete existing cookies and configure how websites can set new cookies</li>
                <li>By visiting this Privacy Policy page - you can use the "Reset Cookie Preferences" button below to clear your current preferences and be prompted to make new choices</li>
                <li>When you see the cookie consent banner - which appears when you first visit our site or after resetting your preferences</li>
            </ul>

            <p>For more information about cookies and how to manage them, visit <a href="http://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer">www.allaboutcookies.org</a>.</p>
            
            <h2>6. Your Rights</h2>
            <p>You have the right to access, correct, or delete your personal information at any time. If you would like to review or update your data, please contact us at the details provided below.</p>
            <p>If you opt into receiving promotional emails, you can unsubscribe at any time by clicking the "unsubscribe" link in the email or by contacting us directly.</p>

            <h2>7. Changes to This Privacy Policy</h2>
            <p>We reserve the right to update this Privacy Policy from time to time. Any changes will be posted on this page, and the "Last Updated" date will be revised accordingly. It is your responsibility to review this policy periodically.</p>

            <h2>8. Contact Information</h2>
            <p>If you have any questions or concerns regarding this Privacy Policy, please contact us.</p>


        </div>
    )
}

export default PrivacyPolicy;